/* eslint-disable quotes */
export default {
  invoice_manage: 'Invoice Management',

  invoice_info_line_1:
    ' Recharged funds are not eligible for direct invoicing. InGame only supports issuing invoices for',
  invoice_info_line_2: ' the consumed cash amount',
  invoice_info_line_3: ' issuing invoices',
  invoice_info_line_4: ' In accordance with tax compliance requirements,',
  invoice_info_line_5:
    ' the VAT special invoice header must strictly match the real-name information of the account',
  invoice_info_line_6:
    '. InGame does not support any requests to change the special invoice header in any scenario. If you need to change the special invoice header, please modify the enterprise real-name authentication information first.',

  can_open_amount: 'Invoiceable Amount(¥)',
  already_open_amount: 'Actual Invoiced Amount(¥)',
  less_open_amount: 'Remaining Eligible Invoice Amount(¥)',
  invoice_history: 'Invoice History',
  bill_pay_time: 'Order/Bill Payment Time',
  bill_pay_money: 'Actual Payment Amount(¥)',
  bill_id: 'Bill Number',
  bill: 'Bill',
  bill_year: ' Year',
  bill_month: ' Month',

  invoice_header_title: 'Invoice Information',
  invoice_header_warn:
    "Please verify the invoice information with your company's financial personnel to ensure the information is filled out correctly to avoid affecting the subsequent use of the invoice.",
  manage_invoice_header: 'Manage Invoice Information',
  invoice_header_type: 'Header Type',
  enterprise: 'Enterprise',
  invoice_type: 'Invoice Type',
  invoice_medium: 'Invoice Medium',
  invoice_common: 'VAT Ordinary Invoice',
  invoice_special: 'VAT Special Invoice',
  invoice_header_name: 'Invoice Header',
  invoice_header_code: 'Taxpayer Identification Number',
  invoice_bank: 'Basic Bank Account',
  invoice_bank_account: 'Basic Bank Account Number',
  invoice_address: 'Enterprise Registered Address',
  invoice_phone: 'Enterprise Registered Phone',
  invoice_id_code_info: '15-20 digits',
  invoice_bank_info:
    'Please fill in the bank name on the account opening permit.',
  invoice_bank_account_info:
    'Please fill in the bank account number on the account opening permit.',
  invoice_cert_info:
    'Please fill in the registered address on the business license.',
  invoice_phone_info:
    'Please fill in the valid contact phone number of the enterprise.',

  email_info: 'Email Information',
  email_manage: 'Manage Email Information',
  email_default: 'Default',
  email_set_default: 'Set as Default',
  email_modify: 'Modify',
  email_delete: 'Delete',
  email_title: 'Email Address',
  email_add: 'Add',

  can_invoice_bills: 'Invoiceable Orders',
  bill_as_detail: 'By Consumption Details',
  bill_as_month: 'By Monthly Bill Summary',
  bill_product_name: 'Produce Name',

  apply_invoice: 'Apply for Invoice',
  apply_total_invoice_amount: 'Total Invoice Amount',
  apply_item_name: 'Item Name',
  apply_specification_model: 'Specification Model',
  apply_unit: 'Unit',
  apply_quantity: 'Quantity',
  apply_unit_price: 'Unit Price (¥)',
  apply_amount: 'Amount (¥)',
  apply_tax_rate: 'Tax Rate',
  apply_tax_amount: 'Tax Amount (¥)',
  apply_modify: 'Modify',
  apply_electronic_invoice: 'Electronic Invoice',
  apply_electronic_invoice_note:
    'Electronic invoices do not display the bank information of the buyer and seller by default. If you wish to display it, please manually select:',
  apply_receive_email: 'Receive Email',
  apply_invoice_remarks_optional: 'Invoice Remarks (Optional)',
  apply_invoice_remarks_note:
    'Fill in and print in the remarks section of the invoice',
  apply_invoice_remarks_limit:
    'Invoice remarks cannot exceed 230 bytes, one Chinese character is 2 bytes',
  apply_next_step: 'Next Step',
  down_invoice: 'Download Electronic Invoice',

  invoice_id: 'Invoice Number',
  invoice_status: 'Invoice Status',
  apply_invoice_time: 'Invoice Application Time',
  apply_invoice_road: 'Invoice Application Method',
  manual_apply_invoice: 'Manual Invoice Application',
  invoice_status_applying: 'Applying',
  invoice_status_opening: 'Invoicing',
  invoice_status_success: 'Success',
  invoice_status_fail: 'Failed',

  invoice_confirm: 'Confirm Invoice Information',
  invoice_preview: 'Invoice Preview',
  invoice_apply_failed: 'Submission Failed',
  invoice_have_apply: 'Invoice Application Submitted',
  invoice_view_in_email: 'Please check your reserved email for further details',
  invoice_preview_info_1:
    "Please verify the invoice information with your company's financial personnel to ensure the details are correctly filled out to avoid any issues with the subsequent use of the invoice. Invoices issued on the same day can be verified as early as the next day on the National VAT Invoice Verification Platform of the State Taxation Administration.",
  invoice_preview_info_2:
    'If the invoice involves multiple tax rates, separate invoices will be issued. Please refer to the actual tax rate on the invoice. Cloud service products are taxed at 6%, with the name of goods or taxable services listed as "Information Technology Services - Cloud Service Fee." Software products are taxed at 13%, with the name of goods or taxable services listed as "Software - Software Product Sales," and these cannot be altered.',
  invoice_electron_info:
    'By default, electronic invoices do not display the bank account information of the buyer or seller. If you wish to display this information, please manually select the option: ',
  invoice_show_buyer: 'Display Buyer Information',
  invoice_show_seller: 'Display Seller Information',
};
